import getTablePartController from './controller';
import getTPCommandPanel from './commandPanels';

export { getTPCommandPanel };

export default getTablePartController;
